
import hsOrderTypes from '@/resources/enums/hsOrderTypes.js'
export default function (hsOrderTypeCode) {
  if (!hsOrderTypeCode && hsOrderTypeCode !== 0) return
  const humanStatus = Object.values(hsOrderTypes).find(type => type.api === hsOrderTypeCode).human
  return humanStatus
}
